<div class="summary-card-container summary-card-top-margin">
  <div class="summary-card-header">Ontwerp</div>
  <mat-card class="top-card mat-elevation-z0 summary-card black-border-color">
    <div class="small-upper-space d-flex">
      <div class="configuration-container">
        <div class="bold-card-title">
          {{
            product.newDesign
              | formatBoolean
                : false
                : 'De klant levert het ontwerp aan'
                : 'Inpress maakt het ontwerp aan'
          }}
        </div>

        <ul
          class="inpress-ul"
          [ngClass]="product.newDesign != null ? 'upper-space' : ''"
        >
          <li>
            <span>Titel: </span>
            <span class="strong">{{ product.title | or : 'Geen titel' }}</span>
          </li>
          <li>
            <span class="preserve-line-break display-contents">{{
              multiplePhoneNumbers ? 'Telnrs: ' : 'Telnr: '
            }}</span>
            <span
              *ngFor="
                let group of productPhoneNumberGroups;
                let last = last;
                let count = count;
                trackBy: trackById
              "
            >
              <span class="strong" *ngIf="count > 1"
                >{{ group.companyName }}:</span
              >
              <span
                *ngFor="
                  let phoneNumber of group.phoneNumbers;
                  let ilast = last;
                  let icount = count
                "
              >
                <a
                  class="click-link strong"
                  href="tel:{{ phoneNumber | asFormatPhoneNumber }}"
                  >{{ phoneNumber | asFormatPhoneNumber }}</a
                >
                <span class="strong">{{
                  !ilast && icount > 1 ? ', ' : ''
                }}</span>
              </span>
              <span class="strong">{{ !last && count > 1 ? ' / ' : '' }}</span>
            </span>
            <span class="strong" *ngIf="productPhoneNumberGroups.length === 0">
              Geen telefoonnummers
            </span>
          </li>
          <li>
            <span class="preserve-line-break display-contents">
              <span>Tekst: </span>
              <span class="inline-flex strong">{{
                product.text | or : 'Geen tekst'
              }}</span>
            </span>
          </li>
        </ul>

        <div *ngIf="product.immoscoopLogo" class="upper-space d-flex">
          <img src="/assets/immoscoop_banner.png" class="immoscoop-logo" />
          <div class="immoscoop-text-container">
            <div class="immoscoop-text">Het Immoscoop logo toevoegen</div>
          </div>
        </div>

        <div *ngIf="product.spottoLogo" class="upper-space d-flex">
          <img src="/assets/spotto_banner.png" class="spotto-logo" />
          <div class="spotto-text-container">
            <div class="spotto-text">Het Spotto logo toevoegen</div>
          </div>
        </div>
      </div>
      <div class="example-container">
        <div class="design-images">
          <ng-container *ngFor="let asset of product.productAssets">
            <div
              *ngIf="
                !asset.archived &&
                asset.formSection === 'externalDesign' &&
                isImage(asset.asset)
              "
            >
              <a
                class="click-link"
                href="/api/assets/{{ asset.asset.uuid }}"
                data-lightbox="design-images"
              >
                <img
                  class="design-image"
                  src="/api/assets/{{ asset.asset.uuid }}"
                />
              </a>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </mat-card>
</div>
